import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { Text, Input, Icon, Box, Flex, Divider, Spinner } from '@chakra-ui/react';
import { LocationMarkerFilled } from "../icons/icons"
import React from 'react'

const PlacesAutocompleteSafe = PlacesAutocomplete as unknown as React.ComponentType<Record<string, unknown>>

const LocationPicker = ({ location, setLocation , setCoordinates, placeholder, fontSize } : {
    location : string,
    setLocation : (v : string) => void,
    setCoordinates ?: (v : {lat : number, lng : number}) => void,
    placeholder ?: string,
    fontSize ?: string
}) => {

    const handleSelect = async (value : any) => {
        try {
            const results = await geocodeByAddress(value);
            const latLng = await getLatLng(results[0]);
            if (setCoordinates) {
                setCoordinates({ lat : latLng.lat, lng : latLng.lng })
            }
            setLocation(value)
        } catch (error) {
            console.log('Geocode error:', error)
        }
    }
    return (
    <PlacesAutocompleteSafe
        value={location}
        onChange={(e: string) => setLocation(e)}

        onSelect={handleSelect}
        onError={() => {}}
    >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading } : any) => (
            
        <div>
            <Box
                position='relative'
            >
                <Flex p='12px' gap='10px' alignItems='center'>
                    <Input
                        {...getInputProps()}
                        placeholder={placeholder ?? 'Add a location...'} 
                        variant='unstyled' 
                        _placeholder={{ color:'#171C22', opacity:'40%' }}
                        color='#171C22'
                        fontWeight='500'
                        fontSize={fontSize ?? 'md'}
                    />
                    {loading ? <Spinner/> : <Icon w='24px' h='24px' color='#171C22'>
                        <LocationMarkerFilled />
                    </Icon>}

                    {((location.length > 1 && suggestions.length > 0) && !loading) && 
                        <Box w='100%' pos='absolute' zIndex='1' bottom='60px'
                            overflow='hidden'
                            pb='4px' pt='4px'
                            bg='white' boxShadow='0px 6px 35px 5px #0000001F'
        
                            borderColor='neutral.100' borderWidth='1px' borderRadius='8px'
                        >
                        {suggestions.map((suggestion : any,i : number) => {
                            return <>
                            
                                <Flex key={suggestion.id} h='60px' p='2px 16px' cursor='pointer' alignItems='center'
                                    _hover={{bg:'neutral.50'}}
                                    transition='0.2s ease-out'
                                    {...getSuggestionItemProps(suggestion)}
                                >
                                    <Box>
                                        <Text
                                            fontSize='md'
                                            fontWeight='600'
                                            color='black'
                                            noOfLines={1}
                                        >{suggestion.formattedSuggestion.mainText}</Text>
                                        <Text
                                            fontSize='sm'
                                            fontWeight='400'
                                            color='gray.700'
                                            noOfLines={1}
            
                                        >{suggestion.formattedSuggestion.secondaryText}</Text>
                                    </Box>
                                </Flex>
                                {i !== suggestions.length - 1 && <Divider />}
                            </>
                        })}
                        </Box>
                    }
                    </Flex>
                </Box>
                        
        </div>
        )}
    </PlacesAutocompleteSafe>
)}
export default LocationPicker